module.exports = __webpack_public_path__ + "static/media/ic_方案_pr.593770f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_方案_pr.svg
// module id = 198
// module chunks = 0